import CircleMarker from './ConflictsIndicator';

export default CircleMarker;
